import React from 'react'
import { useNavigate } from 'react-router-dom'
import {
  Container,
  Content,
  Header,
  BackButton,
  Title,
  LastUpdated,
  Section,
  SectionTitle,
  Paragraph,
  List,
  ListItem,
  Footer,
  HomeButton,
} from './styled'

export const TermsOfUse: React.FC = () => {
  const navigate = useNavigate()

  return (
    <Container>
      <Content>
        <Header>
          <BackButton onClick={() => navigate(-1)}>← Back</BackButton>
          <Title>Terms of Use</Title>
          <LastUpdated>Last updated: December 2024</LastUpdated>
        </Header>

        <Section>
          <SectionTitle>1. Acceptance of Terms</SectionTitle>
          <Paragraph>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
            ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
            aliquip ex ea commodo consequat. Duis aute irure dolor in
            reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
            pariatur.
          </Paragraph>
        </Section>

        <Section>
          <SectionTitle>2. Use of Service</SectionTitle>
          <Paragraph>
            Excepteur sint occaecat cupidatat non proident, sunt in culpa qui
            officia deserunt mollit anim id est laborum. Sed ut perspiciatis
            unde omnis iste natus error sit voluptatem accusantium doloremque
            laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore
            veritatis.
          </Paragraph>
          <List>
            <ListItem>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit
            </ListItem>
            <ListItem>
              Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua
            </ListItem>
            <ListItem>
              Ut enim ad minim veniam, quis nostrud exercitation
            </ListItem>
            <ListItem>
              Ullamco laboris nisi ut aliquip ex ea commodo consequat
            </ListItem>
          </List>
        </Section>

        <Section>
          <SectionTitle>3. User Accounts</SectionTitle>
          <Paragraph>
            Et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim
            ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit,
            sed quia consequuntur magni dolores eos qui ratione voluptatem sequi
            nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit
            amet.
          </Paragraph>
        </Section>

        <Section>
          <SectionTitle>4. Content and Ownership</SectionTitle>
          <Paragraph>
            Consectetur, adipisci velit, sed quia non numquam eius modi tempora
            incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut
            enim ad minima veniam, quis nostrum exercitationem ullam corporis
            suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur.
          </Paragraph>
        </Section>

        <Section>
          <SectionTitle>5. Privacy</SectionTitle>
          <Paragraph>
            Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse
            quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat
            quo voluptas nulla pariatur. At vero eos et accusamus et iusto odio
            dignissimos ducimus qui blanditiis.
          </Paragraph>
        </Section>

        <Section>
          <SectionTitle>6. Prohibited Uses</SectionTitle>
          <Paragraph>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor:
          </Paragraph>
          <List>
            <ListItem>
              Praesentium voluptatum deleniti atque corrupti quos dolores
            </ListItem>
            <ListItem>
              Et quas molestias excepturi sint occaecati cupiditate non
              provident
            </ListItem>
            <ListItem>
              Similique sunt in culpa qui officia deserunt mollitia animi
            </ListItem>
            <ListItem>Id est laborum et dolorum fuga</ListItem>
            <ListItem>
              Et harum quidem rerum facilis est et expedita distinctio
            </ListItem>
          </List>
        </Section>

        <Section>
          <SectionTitle>7. Termination</SectionTitle>
          <Paragraph>
            Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil
            impedit quo minus id quod maxime placeat facere possimus, omnis
            voluptas assumenda est, omnis dolor repellendus. Temporibus autem
            quibusdam et aut officiis debitis aut rerum necessitatibus.
          </Paragraph>
        </Section>

        <Section>
          <SectionTitle>8. Disclaimer of Warranties</SectionTitle>
          <Paragraph>
            Saepe eveniet ut et voluptates repudiandae sint et molestiae non
            recusandae. Itaque earum rerum hic tenetur a sapiente delectus, ut
            aut reiciendis voluptatibus maiores alias consequatur aut
            perferendis doloribus asperiores repellat.
          </Paragraph>
        </Section>

        <Section>
          <SectionTitle>9. Limitation of Liability</SectionTitle>
          <Paragraph>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
            ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
            aliquip ex ea commodo consequat.
          </Paragraph>
        </Section>

        <Section>
          <SectionTitle>10. Contact Information</SectionTitle>
          <Paragraph>
            If you have any questions about these Terms of Use, please contact
            us at:
          </Paragraph>
          <Paragraph>
            Email: legal@quickcasa-waypoint.com
            <br />
            Address: Lorem ipsum dolor sit amet, consectetur adipiscing elit
          </Paragraph>
        </Section>

        <Footer>
          <HomeButton onClick={() => navigate('/')}>
            Return to Dashboard
          </HomeButton>
        </Footer>
      </Content>
    </Container>
  )
}
